var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	25760: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/core", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_core_fesm2020_core_mjs").then(() => (() => (__webpack_require__(/*! @angular/core */ 22560))))))),
	83731: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/animations", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_animations_fesm2020_animations_mjs").then(() => (() => (__webpack_require__(/*! @angular/animations */ 24851))))))),
	4888: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_common_fesm2020_common_mjs-_ec491").then(() => (() => (__webpack_require__(/*! @angular/common */ 94666))))))),
	10825: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/observers", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_observers_mjs-_9dd21").then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 43773))))))),
	21409: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/layout", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_layout_mjs-_516e1").then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 83278))))))),
	39509: () => (loadStrictSingletonVersionCheckFallback("default", "rxjs", [1,6,6,7], () => (__webpack_require__.e("node_modules_rxjs__esm2015_index_js").then(() => (() => (__webpack_require__(/*! rxjs */ 25906))))))),
	56198: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/coercion", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_coercion_mjs-_e7881").then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 48971))))))),
	59779: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/keycodes", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_keycodes_mjs").then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 28456))))))),
	63420: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/platform", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_platform_mjs-_eeec1").then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 89107))))))),
	99848: () => (loadStrictSingletonVersionCheckFallback("default", "rxjs/operators", [1,6,6,7], () => (__webpack_require__.e("node_modules_rxjs__esm2015_operators_index_js").then(() => (() => (__webpack_require__(/*! rxjs/operators */ 26370))))))),
	54732: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/collections", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_collections_mjs-_15111").then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 11755))))))),
	18643: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/bidi", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_bidi_mjs-_66fb1").then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 72867))))))),
	45394: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/portal", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_portal_mjs-_32ad1").then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 17520))))))),
	73848: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/a11y", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_a11y_mjs-_b54c1").then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 24218))))))),
	87753: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/overlay", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_overlay_mjs-_4b201").then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 25895))))))),
	99027: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/scrolling", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_scrolling_mjs-_93761").then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 76328))))))),
	18709: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/core", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_core_mjs-_b6341").then(() => (() => (__webpack_require__(/*! @angular/material/core */ 59121))))))),
	20525: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/forms", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_forms_fesm2020_forms_mjs-_2e341").then(() => (() => (__webpack_require__(/*! @angular/forms */ 2508))))))),
	71437: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/form-field", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_form-field_mjs-_681a1").then(() => (() => (__webpack_require__(/*! @angular/material/form-field */ 75074))))))),
	11775: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/platform-browser/animations", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2020_animations_mjs-_df801").then(() => (() => (__webpack_require__(/*! @angular/platform-browser/animations */ 37146))))))),
	15086: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/dialog", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_dialog_mjs-_b1e01").then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 62529))))))),
	60759: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_cdk_mjs-_1e771").then(() => (() => (__webpack_require__(/*! @angular/cdk */ 46507))))))),
	91180: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/button", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_button_mjs-_f16f1").then(() => (() => (__webpack_require__(/*! @angular/material/button */ 84522))))))),
	8751: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/input", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_input_mjs-_4df01").then(() => (() => (__webpack_require__(/*! @angular/material/input */ 68562))))))),
	55513: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/accordion", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_accordion_mjs-_cc711").then(() => (() => (__webpack_require__(/*! @angular/cdk/accordion */ 32088))))))),
	26353: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/common/http", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_common_fesm2020_http_mjs-_68761").then(() => (() => (__webpack_require__(/*! @angular/common/http */ 58987))))))),
	47783: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/platform-browser", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_platform-browser_fesm2020_platform-browser_mjs-_18081").then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 34497))))))),
	18990: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/text-field", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_text-field_mjs-_d10b1").then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 35804))))))),
	89022: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/divider", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_divider_mjs-_30d41").then(() => (() => (__webpack_require__(/*! @angular/material/divider */ 71528))))))),
	1972: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/select", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_select_mjs-_8caa1").then(() => (() => (__webpack_require__(/*! @angular/material/select */ 57371))))))),
	13918: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/tooltip", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_tooltip_mjs-_31b71").then(() => (() => (__webpack_require__(/*! @angular/material/tooltip */ 6896))))))),
	53079: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/stepper", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_stepper_mjs-_253b1").then(() => (() => (__webpack_require__(/*! @angular/cdk/stepper */ 41861))))))),
	31869: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/icon", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_icon_mjs-_1a881").then(() => (() => (__webpack_require__(/*! @angular/material/icon */ 57822))))))),
	87773: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/table", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_table_mjs-_f6c21").then(() => (() => (__webpack_require__(/*! @angular/cdk/table */ 59673))))))),
	97659: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/tree", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_tree_mjs-_d2801").then(() => (() => (__webpack_require__(/*! @angular/cdk/tree */ 15183))))))),
	66043: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/animations/browser", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_animations_fesm2020_browser_mjs-_54670").then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 5787))))))),
	89265: () => (loadStrictSingletonVersionCheckFallback("default", "@awesome-cordova-plugins/core", [1,6,16,0], () => (__webpack_require__.e("node_modules_awesome-cordova-plugins_core_index_js").then(() => (() => (__webpack_require__(/*! @awesome-cordova-plugins/core */ 49471))))))),
	34572: () => (loadStrictSingletonVersionCheckFallback("default", "@ionic-native/core", [1,5,36,0], () => (__webpack_require__.e("node_modules_ionic-native_core___ivy_ngcc___index_js").then(() => (() => (__webpack_require__(/*! @ionic-native/core */ 68751))))))),
	60140: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/router", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_router_fesm2020_router_mjs-_6f001").then(() => (() => (__webpack_require__(/*! @angular/router */ 60124))))))),
	31796: () => (loadStrictSingletonVersionCheckFallback("default", "hammerjs", [1,2,0,8], () => (__webpack_require__.e("node_modules_hammerjs_hammer_js").then(() => (() => (__webpack_require__(/*! hammerjs */ 15977))))))),
	95761: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/snack-bar", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_snack-bar_mjs-_84760").then(() => (() => (__webpack_require__(/*! @angular/material/snack-bar */ 10930))))))),
	77207: () => (loadStrictSingletonVersionCheckFallback("default", "@ngx-translate/core", [1,14,0,0], () => (__webpack_require__.e("node_modules_ngx-translate_core_fesm2020_ngx-translate-core_mjs-_ea9c0").then(() => (() => (__webpack_require__(/*! @ngx-translate/core */ 38699))))))),
	83073: () => (loadStrictSingletonVersionCheckFallback("default", "@ionic/angular", [1,6,6,0], () => (__webpack_require__.e("node_modules_ionic_angular_fesm2015_ionic-angular_js-_e9c90").then(() => (() => (__webpack_require__(/*! @ionic/angular */ 93819))))))),
	53087: () => (loadStrictSingletonVersionCheckFallback("default", "@ngx-translate/http-loader", [1,7,0,0], () => (__webpack_require__.e("node_modules_ngx-translate_http-loader_fesm2020_ngx-translate-http-loader_mjs").then(() => (() => (__webpack_require__(/*! @ngx-translate/http-loader */ 58319))))))),
	72564: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/cdk/drag-drop", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_cdk_fesm2020_drag-drop_mjs-_11e30").then(() => (() => (__webpack_require__(/*! @angular/cdk/drag-drop */ 47727))))))),
	79946: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/autocomplete", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_autocomplete_mjs-_32bf0").then(() => (() => (__webpack_require__(/*! @angular/material/autocomplete */ 88550))))))),
	35023: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/badge", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_badge_mjs-_53dc0").then(() => (() => (__webpack_require__(/*! @angular/material/badge */ 83335))))))),
	65625: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/bottom-sheet", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_bottom-sheet_mjs-_92340").then(() => (() => (__webpack_require__(/*! @angular/material/bottom-sheet */ 64865))))))),
	20135: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/button-toggle", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_button-toggle_mjs-_ca170").then(() => (() => (__webpack_require__(/*! @angular/material/button-toggle */ 19837))))))),
	87346: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/card", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_card_mjs-_a9900").then(() => (() => (__webpack_require__(/*! @angular/material/card */ 82156))))))),
	17198: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/checkbox", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_checkbox_mjs-_e91d0").then(() => (() => (__webpack_require__(/*! @angular/material/checkbox */ 44792))))))),
	56710: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/chips", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_chips_mjs-_1bc60").then(() => (() => (__webpack_require__(/*! @angular/material/chips */ 11169))))))),
	5422: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/stepper", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_stepper_mjs-_1ffc0").then(() => (() => (__webpack_require__(/*! @angular/material/stepper */ 44193))))))),
	35562: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/datepicker", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_datepicker_mjs-_f11d0").then(() => (() => (__webpack_require__(/*! @angular/material/datepicker */ 42298))))))),
	31003: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/dialog", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_dialog_mjs-_03ec0").then(() => (() => (__webpack_require__(/*! @angular/material/dialog */ 31484))))))),
	70294: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/expansion", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_expansion_mjs-_0d8f0").then(() => (() => (__webpack_require__(/*! @angular/material/expansion */ 17591))))))),
	49733: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/grid-list", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_grid-list_mjs-_64cf0").then(() => (() => (__webpack_require__(/*! @angular/material/grid-list */ 42642))))))),
	87967: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/list", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_list_mjs-_6e620").then(() => (() => (__webpack_require__(/*! @angular/material/list */ 6517))))))),
	74102: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/menu", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_menu_mjs-_68930").then(() => (() => (__webpack_require__(/*! @angular/material/menu */ 88589))))))),
	38854: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/paginator", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_paginator_mjs-_52eb0").then(() => (() => (__webpack_require__(/*! @angular/material/paginator */ 36060))))))),
	87650: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/progress-bar", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_progress-bar_mjs-_71810").then(() => (() => (__webpack_require__(/*! @angular/material/progress-bar */ 51294))))))),
	85545: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/progress-spinner", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_progress-spinner_mjs-_52450").then(() => (() => (__webpack_require__(/*! @angular/material/progress-spinner */ 61708))))))),
	73989: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/radio", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_radio_mjs-_e3660").then(() => (() => (__webpack_require__(/*! @angular/material/radio */ 52922))))))),
	65256: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/sidenav", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_sidenav_mjs-_946c0").then(() => (() => (__webpack_require__(/*! @angular/material/sidenav */ 16643))))))),
	9364: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/slider", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_slider_mjs-_c20f0").then(() => (() => (__webpack_require__(/*! @angular/material/slider */ 5682))))))),
	98067: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/slide-toggle", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_slide-toggle_mjs-_df100").then(() => (() => (__webpack_require__(/*! @angular/material/slide-toggle */ 84714))))))),
	73786: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/sort", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_sort_mjs-_5f6b0").then(() => (() => (__webpack_require__(/*! @angular/material/sort */ 92197))))))),
	31507: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/table", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_table_mjs-_150c0").then(() => (() => (__webpack_require__(/*! @angular/material/table */ 85288))))))),
	1067: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/tabs", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_tabs_mjs-_be8a0").then(() => (() => (__webpack_require__(/*! @angular/material/tabs */ 15892))))))),
	48549: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/toolbar", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_toolbar_mjs-_15e80").then(() => (() => (__webpack_require__(/*! @angular/material/toolbar */ 52543))))))),
	19273: () => (loadStrictSingletonVersionCheckFallback("default", "@angular/material/tree", [1,15,2,0], () => (__webpack_require__.e("node_modules_angular_material_fesm2020_tree_mjs-_9d740").then(() => (() => (__webpack_require__(/*! @angular/material/tree */ 53453))))))),
	19140: () => (loadStrictSingletonVersionCheckFallback("default", "ng2-dragula", [1,2,1,1], () => (__webpack_require__.e("node_modules_ng2-dragula___ivy_ngcc___dist_fesm2015_ng2-dragula_js-_efd00").then(() => (() => (__webpack_require__(/*! ng2-dragula */ 48370))))))),
	82870: () => (loadStrictSingletonVersionCheckFallback("default", "@danielmoncada/angular-datetime-picker", [1,15,0,2], () => (__webpack_require__.e("node_modules_danielmoncada_angular-datetime-picker_fesm2020_danielmoncada-angular-datetime-pi-f084730").then(() => (() => (__webpack_require__(/*! @danielmoncada/angular-datetime-picker */ 43829))))))),
	62473: () => (loadStrictSingletonVersionCheckFallback("default", "@awesome-cordova-plugins/camera/ngx", [1,6,16,0], () => (__webpack_require__.e("node_modules_awesome-cordova-plugins_camera_ngx_index_js-_60e10").then(() => (() => (__webpack_require__(/*! @awesome-cordova-plugins/camera/ngx */ 82543))))))),
	71555: () => (loadStrictSingletonVersionCheckFallback("default", "@awesome-cordova-plugins/web-intent/ngx", [1,8,1,0], () => (__webpack_require__.e("node_modules_awesome-cordova-plugins_web-intent_ngx_index_js-_dbfa0").then(() => (() => (__webpack_require__(/*! @awesome-cordova-plugins/web-intent/ngx */ 86973))))))),
	20606: () => (loadStrictSingletonVersionCheckFallback("default", "file-saver", [1,2,0,5], () => (__webpack_require__.e("node_modules_file-saver_dist_FileSaver_min_js").then(() => (() => (__webpack_require__(/*! file-saver */ 65226))))))),
	66621: () => (loadStrictSingletonVersionCheckFallback("default", "xlsx", [2,0,18,5], () => (__webpack_require__.e("node_modules_xlsx_xlsx_mjs").then(() => (() => (__webpack_require__(/*! xlsx */ 4126))))))),
	16381: () => (loadStrictSingletonVersionCheckFallback("default", "js-sha512", [2,0,8,0], () => (__webpack_require__.e("node_modules_js-sha512_src_sha512_js").then(() => (() => (__webpack_require__(/*! js-sha512 */ 22414))))))),
	32071: () => (loadStrictSingletonVersionCheckFallback("default", "jspdf", [1,3,0,1], () => (__webpack_require__.e("node_modules_jspdf_dist_jspdf_es_min_js").then(() => (() => (__webpack_require__(/*! jspdf */ 84177))))))),
	52949: () => (loadStrictSingletonVersionCheckFallback("default", "html2canvas", [1,1,4,1], () => (__webpack_require__.e("node_modules_html2canvas_dist_html2canvas_js").then(() => (() => (__webpack_require__(/*! html2canvas */ 9266))))))),
	56934: () => (loadStrictSingletonVersionCheckFallback("default", "@ionic-native/app-availability/ngx", [1,5,36,0], () => (__webpack_require__.e("node_modules_ionic-native_app-availability___ivy_ngcc___ngx_index_js-_53590").then(() => (() => (__webpack_require__(/*! @ionic-native/app-availability/ngx */ 62067))))))),
	31401: () => (loadStrictSingletonVersionCheckFallback("default", "@google-pay/button-angular", [1,3,2,1], () => (__webpack_require__.e("node_modules_google-pay_button-angular_fesm2020_google-pay-button-angular_mjs-_a0af0").then(() => (() => (__webpack_require__(/*! @google-pay/button-angular */ 76550))))))),
	42359: () => (loadStrictSingletonVersionCheckFallback("default", "@ionic-native/all-in-one-sdk/ngx", [1,5,36,0], () => (__webpack_require__.e("node_modules_ionic-native_all-in-one-sdk___ivy_ngcc___ngx_index_js").then(() => (() => (__webpack_require__(/*! @ionic-native/all-in-one-sdk/ngx */ 98380))))))),
	14462: () => (loadStrictSingletonVersionCheckFallback("default", "@awesome-cordova-plugins/in-app-browser/ngx", [1,8,1,0], () => (__webpack_require__.e("node_modules_awesome-cordova-plugins_in-app-browser_ngx_index_js-_fb000").then(() => (() => (__webpack_require__(/*! @awesome-cordova-plugins/in-app-browser/ngx */ 67122))))))),
	36100: () => (loadStrictSingletonVersionCheckFallback("default", "@awesome-cordova-plugins/splash-screen/ngx", [1,8,1,0], () => (__webpack_require__.e("node_modules_awesome-cordova-plugins_splash-screen_ngx_index_js-_43760").then(() => (() => (__webpack_require__(/*! @awesome-cordova-plugins/splash-screen/ngx */ 10696))))))),
	73968: () => (loadStrictSingletonVersionCheckFallback("default", "@ionic-native/social-sharing/ngx", [1,5,36,0], () => (__webpack_require__.e("node_modules_ionic-native_social-sharing___ivy_ngcc___ngx_index_js-_17610").then(() => (() => (__webpack_require__(/*! @ionic-native/social-sharing/ngx */ 96772))))))),
	73731: () => (loadStrictSingletonVersionCheckFallback("default", "@ionic-native/file/ngx", [1,5,36,0], () => (__webpack_require__.e("node_modules_ionic-native_file___ivy_ngcc___ngx_index_js-_82dc0").then(() => (() => (__webpack_require__(/*! @ionic-native/file/ngx */ 12358))))))),
	27264: () => (loadStrictSingletonVersionCheckFallback("default", "angular4-paystack", [1,3,1,4], () => (__webpack_require__.e("node_modules_angular4-paystack_fesm2022_angular4-paystack_mjs-_dd430").then(() => (() => (__webpack_require__(/*! angular4-paystack */ 16520)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"node_modules_angular_animations_fesm2020_browser_mjs-_54671": [
		25760,
		83731
	],
	"node_modules_angular_cdk_fesm2020_a11y_mjs-_b54c0": [
		4888,
		10825,
		21409,
		25760,
		39509,
		56198,
		59779,
		63420,
		99848
	],
	"node_modules_angular_cdk_fesm2020_accordion_mjs-_cc710": [
		25760,
		39509,
		54732,
		56198
	],
	"node_modules_angular_cdk_fesm2020_bidi_mjs-_66fb0": [
		4888,
		25760
	],
	"node_modules_angular_cdk_fesm2020_coercion_mjs-_e7880": [
		25760
	],
	"node_modules_angular_cdk_fesm2020_collections_mjs-_15110": [
		25760,
		39509
	],
	"node_modules_angular_cdk_fesm2020_dialog_mjs-_b1e00": [
		4888,
		18643,
		25760,
		39509,
		45394,
		59779,
		63420,
		73848,
		87753,
		99848
	],
	"node_modules_angular_cdk_fesm2020_drag-drop_mjs-_11e31": [
		25760,
		4888,
		99027,
		63420,
		56198,
		73848,
		39509,
		99848,
		18643
	],
	"node_modules_angular_cdk_fesm2020_layout_mjs-_516e0": [
		25760,
		39509,
		56198,
		63420,
		99848
	],
	"node_modules_angular_cdk_fesm2020_observers_mjs-_9dd20": [
		25760,
		39509,
		56198,
		99848
	],
	"node_modules_angular_cdk_fesm2020_overlay_mjs-_4b200": [
		4888,
		18643,
		25760,
		39509,
		45394,
		56198,
		59779,
		63420,
		99027,
		99848
	],
	"node_modules_angular_cdk_fesm2020_platform_mjs-_eeec0": [
		4888,
		25760
	],
	"node_modules_angular_cdk_fesm2020_portal_mjs-_32ad0": [
		4888,
		25760
	],
	"node_modules_angular_cdk_fesm2020_scrolling_mjs-_93760": [
		4888,
		18643,
		25760,
		39509,
		54732,
		56198,
		63420,
		99848
	],
	"node_modules_angular_cdk_fesm2020_stepper_mjs-_253b0": [
		18643,
		25760,
		39509,
		56198,
		59779,
		63420,
		73848,
		99848
	],
	"node_modules_angular_cdk_fesm2020_table_mjs-_f6c20": [
		4888,
		18643,
		25760,
		39509,
		54732,
		56198,
		63420,
		99027,
		99848
	],
	"node_modules_angular_cdk_fesm2020_text-field_mjs-_d10b0": [
		4888,
		25760,
		39509,
		56198,
		63420,
		99848
	],
	"node_modules_angular_cdk_fesm2020_tree_mjs-_d2800": [
		18643,
		25760,
		39509,
		54732,
		56198,
		99848
	],
	"node_modules_angular_cdk_fesm2020_cdk_mjs-_1e770": [
		25760
	],
	"node_modules_angular_common_fesm2020_http_mjs-_68760": [
		4888,
		25760,
		39509,
		99848
	],
	"node_modules_angular_common_fesm2020_common_mjs-_ec490": [
		25760
	],
	"node_modules_angular_core_fesm2020_core_mjs": [
		39509,
		99848
	],
	"node_modules_angular_forms_fesm2020_forms_mjs-_2e340": [
		4888,
		25760,
		39509,
		99848
	],
	"node_modules_angular_material_fesm2020_autocomplete_mjs-_32bf1": [
		25760,
		18709,
		4888,
		99027,
		87753,
		73848,
		56198,
		63420,
		83731,
		39509,
		59779,
		45394,
		20525,
		71437,
		99848,
		18643
	],
	"node_modules_angular_material_fesm2020_badge_mjs-_53dc1": [
		25760,
		18709,
		73848,
		56198,
		11775
	],
	"node_modules_angular_material_fesm2020_bottom-sheet_mjs-_92341": [
		15086,
		45394,
		25760,
		18709,
		73848,
		21409,
		87753,
		4888,
		83731,
		59779,
		39509,
		99848
	],
	"node_modules_angular_material_fesm2020_button-toggle_mjs-_ca171": [
		73848,
		56198,
		54732,
		25760,
		20525,
		18709
	],
	"node_modules_angular_material_fesm2020_button_mjs-_f16f0": [
		11775,
		18709,
		25760,
		56198,
		63420,
		73848
	],
	"node_modules_angular_material_fesm2020_card_mjs-_a9901": [
		25760,
		4888,
		18709
	],
	"node_modules_angular_material_fesm2020_checkbox_mjs-_e91d1": [
		25760,
		20525,
		18709,
		11775,
		56198
	],
	"node_modules_angular_material_fesm2020_chips_mjs-_1bc61": [
		56198,
		11775,
		25760,
		4888,
		18709,
		73848,
		39509,
		99848,
		59779,
		18643,
		20525,
		71437
	],
	"node_modules_angular_material_fesm2020_core_mjs-_b6340": [
		4888,
		11775,
		18643,
		25760,
		39509,
		56198,
		59779,
		60759,
		63420,
		73848,
		99848
	],
	"node_modules_angular_material_fesm2020_datepicker_mjs-_f11d1": [
		73848,
		87753,
		45394,
		4888,
		25760,
		91180,
		99027,
		18709,
		39509,
		59779,
		18643,
		63420,
		99848,
		56198,
		83731,
		20525,
		71437,
		8751
	],
	"node_modules_angular_material_fesm2020_dialog_mjs-_03ec1": [
		87753,
		4888,
		25760,
		73848,
		11775,
		15086,
		56198,
		45394,
		39509,
		99848,
		59779,
		18709,
		83731
	],
	"node_modules_angular_material_fesm2020_divider_mjs-_30d40": [
		18709,
		25760,
		56198
	],
	"node_modules_angular_material_fesm2020_expansion_mjs-_0d8f1": [
		55513,
		45394,
		4888,
		25760,
		18709,
		56198,
		73848,
		99848,
		59779,
		11775,
		39509,
		83731,
		54732
	],
	"node_modules_angular_material_fesm2020_form-field_mjs-_681a0": [
		4888,
		10825,
		11775,
		18643,
		18709,
		25760,
		39509,
		56198,
		63420,
		83731,
		99848
	],
	"node_modules_angular_material_fesm2020_grid-list_mjs-_64cf1": [
		25760,
		18709,
		56198,
		18643
	],
	"node_modules_angular_material_fesm2020_icon_mjs-_1a880": [
		4888,
		18709,
		25760,
		26353,
		39509,
		47783,
		56198,
		99848
	],
	"node_modules_angular_material_fesm2020_input_mjs-_4df00": [
		18709,
		18990,
		20525,
		25760,
		39509,
		56198,
		63420,
		71437
	],
	"node_modules_angular_material_fesm2020_list_mjs-_6e621": [
		25760,
		56198,
		63420,
		18709,
		11775,
		39509,
		10825,
		4888,
		89022,
		73848,
		54732,
		59779,
		20525,
		99848
	],
	"node_modules_angular_material_fesm2020_menu_mjs-_68931": [
		25760,
		73848,
		56198,
		59779,
		39509,
		99848,
		18709,
		4888,
		45394,
		83731,
		18643,
		87753,
		63420,
		99027
	],
	"node_modules_angular_material_fesm2020_paginator_mjs-_52eb1": [
		4888,
		25760,
		39509,
		91180,
		1972,
		13918,
		18709,
		56198,
		71437
	],
	"node_modules_angular_material_fesm2020_progress-bar_mjs-_71811": [
		25760,
		4888,
		18709,
		11775,
		56198
	],
	"node_modules_angular_material_fesm2020_progress-spinner_mjs-_52451": [
		25760,
		18709,
		11775,
		56198,
		4888
	],
	"node_modules_angular_material_fesm2020_radio_mjs-_e3661": [
		25760,
		18709,
		73848,
		56198,
		54732,
		11775,
		20525,
		4888
	],
	"node_modules_angular_material_fesm2020_select_mjs-_8caa0": [
		4888,
		18643,
		18709,
		20525,
		25760,
		39509,
		54732,
		56198,
		59779,
		71437,
		73848,
		83731,
		87753,
		99027,
		99848
	],
	"node_modules_angular_material_fesm2020_sidenav_mjs-_946c1": [
		99027,
		4888,
		25760,
		18709,
		73848,
		18643,
		56198,
		59779,
		63420,
		39509,
		99848,
		83731,
		11775
	],
	"node_modules_angular_material_fesm2020_slide-toggle_mjs-_df101": [
		25760,
		20525,
		11775,
		73848,
		18709,
		56198,
		4888
	],
	"node_modules_angular_material_fesm2020_slider_mjs-_c20f1": [
		18643,
		56198,
		63420,
		25760,
		18709,
		11775,
		99848,
		4888,
		20525,
		39509
	],
	"node_modules_angular_material_fesm2020_snack-bar_mjs-_84761": [
		25760,
		39509,
		4888,
		91180,
		83731,
		45394,
		63420,
		99848,
		73848,
		21409,
		87753,
		18709
	],
	"node_modules_angular_material_fesm2020_sort_mjs-_5f6b1": [
		25760,
		73848,
		56198,
		59779,
		18709,
		39509,
		83731,
		4888
	],
	"node_modules_angular_material_fesm2020_stepper_mjs-_1ffc1": [
		45394,
		53079,
		4888,
		25760,
		18709,
		31869,
		73848,
		39509,
		18643,
		99848,
		83731
	],
	"node_modules_angular_material_fesm2020_table_mjs-_150c1": [
		25760,
		87773,
		54732,
		18709,
		39509,
		56198,
		99848
	],
	"node_modules_angular_material_fesm2020_tabs_mjs-_be8a1": [
		4888,
		25760,
		18709,
		45394,
		10825,
		73848,
		18643,
		39509,
		99848,
		83731,
		56198,
		99027,
		63420,
		11775,
		59779
	],
	"node_modules_angular_material_fesm2020_toolbar_mjs-_15e81": [
		25760,
		18709,
		63420,
		4888
	],
	"node_modules_angular_material_fesm2020_tooltip_mjs-_31b70": [
		4888,
		11775,
		18643,
		18709,
		25760,
		39509,
		45394,
		56198,
		59779,
		63420,
		73848,
		83731,
		87753,
		99027,
		99848
	],
	"node_modules_angular_material_fesm2020_tree_mjs-_9d741": [
		97659,
		25760,
		18709,
		56198,
		54732,
		39509,
		99848
	],
	"node_modules_angular_platform-browser_fesm2020_animations_mjs-_df800": [
		4888,
		25760,
		47783,
		66043,
		83731
	],
	"node_modules_angular_platform-browser_fesm2020_platform-browser_mjs-_18080": [
		4888,
		25760
	],
	"node_modules_angular_router_fesm2020_router_mjs-_6f000": [
		4888,
		25760,
		39509,
		47783,
		99848
	],
	"node_modules_awesome-cordova-plugins_camera_ngx_index_js-_60e11": [
		25760,
		89265
	],
	"node_modules_awesome-cordova-plugins_core_index_js": [
		39509
	],
	"node_modules_awesome-cordova-plugins_in-app-browser_ngx_index_js-_fb001": [
		25760,
		89265,
		39509
	],
	"node_modules_awesome-cordova-plugins_splash-screen_ngx_index_js-_43761": [
		25760,
		89265
	],
	"node_modules_awesome-cordova-plugins_web-intent_ngx_index_js-_dbfa1": [
		25760,
		89265,
		39509
	],
	"node_modules_danielmoncada_angular-datetime-picker_fesm2020_danielmoncada-angular-datetime-pi-f084731": [
		25760,
		4888,
		73848,
		87753,
		45394,
		59779,
		56198,
		39509,
		99848,
		83731,
		20525,
		63420
	],
	"node_modules_google-pay_button-angular_fesm2020_google-pay-button-angular_mjs-_a0af1": [
		25760
	],
	"node_modules_ionic-native_all-in-one-sdk___ivy_ngcc___ngx_index_js": [
		34572
	],
	"node_modules_ionic-native_app-availability___ivy_ngcc___ngx_index_js-_53591": [
		25760,
		34572
	],
	"node_modules_ionic-native_core___ivy_ngcc___index_js": [
		39509
	],
	"node_modules_ionic-native_file___ivy_ngcc___ngx_index_js-_82dc1": [
		25760,
		34572
	],
	"node_modules_ionic-native_social-sharing___ivy_ngcc___ngx_index_js-_17611": [
		25760,
		34572
	],
	"node_modules_ionic_angular_fesm2015_ionic-angular_js-_e9c91": [
		25760,
		20525,
		39509,
		60140,
		99848,
		4888
	],
	"node_modules_ngx-translate_core_fesm2020_ngx-translate-core_mjs-_ea9c1": [
		25760,
		39509,
		99848
	],
	"node_modules_angular4-paystack_fesm2022_angular4-paystack_mjs-_dd431": [
		25760,
		4888
	],
	"node_modules_ng2-dragula___ivy_ngcc___dist_fesm2015_ng2-dragula_js-_efd01": [
		25760,
		39509,
		99848
	],
	"src_bootstrap_ts": [
		31796,
		25760,
		47783,
		11775,
		60140,
		26353,
		95761,
		77207,
		83073,
		99848,
		39509,
		4888,
		31869,
		53087,
		73848,
		72564,
		45394,
		99027,
		53079,
		87773,
		97659,
		79946,
		35023,
		65625,
		91180,
		20135,
		87346,
		17198,
		56710,
		5422,
		35562,
		31003,
		89022,
		70294,
		49733,
		8751,
		87967,
		74102,
		18709,
		38854,
		87650,
		85545,
		73989,
		1972,
		65256,
		9364,
		98067,
		73786,
		31507,
		1067,
		48549,
		13918,
		19273,
		19140,
		82870,
		20525,
		62473,
		71555,
		20606,
		66621,
		71437,
		63420,
		16381,
		32071,
		52949,
		56934,
		31401,
		42359,
		14462,
		36100,
		73968,
		73731,
		27264
	],
	"node_modules_angular_cdk_fesm2020_platform_mjs-_eeec1": [
		4888
	],
	"node_modules_angular_cdk_fesm2020_layout_mjs-_516e1": [
		56198,
		63420
	],
	"node_modules_angular_cdk_fesm2020_collections_mjs-_15111": [
		39509
	],
	"node_modules_angular_cdk_fesm2020_a11y_mjs-_b54c1": [
		4888,
		10825,
		21409,
		39509,
		56198,
		59779,
		63420,
		99848
	],
	"node_modules_angular_cdk_fesm2020_overlay_mjs-_4b201": [
		18643,
		45394,
		56198,
		59779,
		63420,
		99027
	],
	"node_modules_angular_cdk_fesm2020_bidi_mjs-_66fb1": [
		4888
	],
	"node_modules_angular_cdk_fesm2020_scrolling_mjs-_93761": [
		18643,
		54732,
		56198,
		63420
	],
	"node_modules_angular_material_fesm2020_core_mjs-_b6341": [
		4888,
		11775,
		18643,
		39509,
		56198,
		59779,
		60759,
		63420,
		73848,
		99848
	],
	"node_modules_angular_forms_fesm2020_forms_mjs-_2e341": [
		4888,
		39509,
		99848
	],
	"node_modules_angular_material_fesm2020_form-field_mjs-_681a1": [
		4888,
		10825,
		11775,
		18643,
		56198,
		63420,
		83731,
		99848
	],
	"node_modules_angular_platform-browser_fesm2020_animations_mjs-_df801": [
		4888,
		47783,
		66043,
		83731
	],
	"node_modules_angular_cdk_fesm2020_dialog_mjs-_b1e01": [
		18643,
		63420
	],
	"node_modules_angular_material_fesm2020_button_mjs-_f16f1": [
		11775,
		56198,
		63420,
		73848
	],
	"node_modules_angular_material_fesm2020_input_mjs-_4df01": [
		18990,
		56198
	],
	"node_modules_angular_cdk_fesm2020_text-field_mjs-_d10b1": [
		4888,
		99848
	],
	"node_modules_angular_material_fesm2020_divider_mjs-_30d41": [
		56198
	],
	"node_modules_angular_material_fesm2020_select_mjs-_8caa1": [
		18643,
		20525,
		54732,
		56198,
		59779,
		73848,
		83731,
		87753,
		99027,
		99848
	],
	"node_modules_angular_material_fesm2020_tooltip_mjs-_31b71": [
		11775,
		18643,
		45394,
		56198,
		59779,
		63420,
		73848,
		83731,
		87753,
		99027,
		99848
	],
	"node_modules_angular_cdk_fesm2020_stepper_mjs-_253b1": [
		18643,
		56198,
		59779,
		63420
	],
	"node_modules_angular_material_fesm2020_icon_mjs-_1a881": [
		26353,
		47783,
		56198
	],
	"node_modules_angular_cdk_fesm2020_table_mjs-_f6c21": [
		4888,
		18643,
		54732,
		56198,
		63420,
		99027
	],
	"node_modules_angular_cdk_fesm2020_tree_mjs-_d2801": [
		18643,
		54732,
		56198
	],
	"node_modules_angular_router_fesm2020_router_mjs-_6f001": [
		47783
	],
	"webpack_sharing_consume_default_html2canvas_html2canvas": [
		52949
	],
	"node_modules_angular_cdk_fesm2020_drag-drop_mjs-_11e30": [
		56198,
		18643
	],
	"node_modules_angular_material_fesm2020_autocomplete_mjs-_32bf0": [
		87753,
		56198,
		83731,
		59779,
		18643
	],
	"node_modules_angular_material_fesm2020_badge_mjs-_53dc0": [
		56198,
		11775
	],
	"node_modules_angular_material_fesm2020_bottom-sheet_mjs-_92340": [
		15086,
		21409,
		87753,
		83731,
		59779
	],
	"node_modules_angular_material_fesm2020_button-toggle_mjs-_ca170": [
		56198,
		54732
	],
	"node_modules_angular_material_fesm2020_checkbox_mjs-_e91d0": [
		11775,
		56198
	],
	"node_modules_angular_material_fesm2020_chips_mjs-_1bc60": [
		56198,
		11775,
		59779,
		18643
	],
	"node_modules_angular_material_fesm2020_stepper_mjs-_1ffc0": [
		18643,
		83731
	],
	"node_modules_angular_material_fesm2020_datepicker_mjs-_f11d0": [
		87753,
		59779,
		18643,
		56198,
		83731
	],
	"node_modules_angular_material_fesm2020_dialog_mjs-_03ec0": [
		87753,
		11775,
		15086,
		56198,
		59779,
		83731
	],
	"node_modules_angular_material_fesm2020_expansion_mjs-_0d8f0": [
		55513,
		56198,
		59779,
		11775,
		83731,
		54732
	],
	"node_modules_angular_material_fesm2020_grid-list_mjs-_64cf0": [
		56198,
		18643
	],
	"node_modules_angular_material_fesm2020_list_mjs-_6e620": [
		56198,
		11775,
		10825,
		54732,
		59779
	],
	"node_modules_angular_material_fesm2020_menu_mjs-_68930": [
		56198,
		59779,
		83731,
		18643,
		87753
	],
	"node_modules_angular_material_fesm2020_paginator_mjs-_52eb0": [
		56198
	],
	"node_modules_angular_material_fesm2020_progress-bar_mjs-_71810": [
		11775,
		56198
	],
	"node_modules_angular_material_fesm2020_progress-spinner_mjs-_52450": [
		11775,
		56198
	],
	"node_modules_angular_material_fesm2020_radio_mjs-_e3660": [
		56198,
		54732,
		11775
	],
	"node_modules_angular_material_fesm2020_sidenav_mjs-_946c0": [
		18643,
		56198,
		59779,
		83731,
		11775
	],
	"node_modules_angular_material_fesm2020_slider_mjs-_c20f0": [
		18643,
		56198,
		11775
	],
	"node_modules_angular_material_fesm2020_slide-toggle_mjs-_df100": [
		11775,
		56198
	],
	"node_modules_angular_material_fesm2020_snack-bar_mjs-_84760": [
		83731,
		21409,
		87753
	],
	"node_modules_angular_material_fesm2020_sort_mjs-_5f6b0": [
		56198,
		59779,
		83731
	],
	"node_modules_angular_material_fesm2020_table_mjs-_150c0": [
		54732,
		56198
	],
	"node_modules_angular_material_fesm2020_tabs_mjs-_be8a0": [
		10825,
		18643,
		83731,
		56198,
		11775,
		59779
	],
	"node_modules_angular_material_fesm2020_tree_mjs-_9d740": [
		56198,
		54732
	],
	"node_modules_danielmoncada_angular-datetime-picker_fesm2020_danielmoncada-angular-datetime-pi-f084730": [
		87753,
		59779,
		56198,
		83731
	],
	"node_modules_awesome-cordova-plugins_camera_ngx_index_js-_60e10": [
		89265
	],
	"node_modules_awesome-cordova-plugins_web-intent_ngx_index_js-_dbfa0": [
		89265
	],
	"node_modules_ionic-native_app-availability___ivy_ngcc___ngx_index_js-_53590": [
		34572
	],
	"node_modules_awesome-cordova-plugins_in-app-browser_ngx_index_js-_fb000": [
		89265
	],
	"node_modules_awesome-cordova-plugins_splash-screen_ngx_index_js-_43760": [
		89265
	],
	"node_modules_ionic-native_social-sharing___ivy_ngcc___ngx_index_js-_17610": [
		34572
	],
	"node_modules_ionic-native_file___ivy_ngcc___ngx_index_js-_82dc0": [
		34572
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}